import { atom } from 'recoil';

export type PageState = {
  location: 'main';
  token: string;
} | {
  location: 'preview';
  token: string;
  questionId: number;
} | {
  location: 'unknown'
}

const initPageState = atom<{initialized: boolean}>({
  key: 'initInputForm',
  default: {initialized: false},
  dangerouslyAllowMutability: true,
});

function getTokenByPath() {
  const fragments = window.location.pathname.split('/').filter(c => c !== '');
  if (fragments.length === 2 && fragments[0] === 'q') {
    return fragments[1];
  } else {
    return null;
  }
}

function getQuery(): {[key:string]: string} {
  return window.location.search.slice(1)
    .split('&')
    .map(q => q.split('=').map(decodeURIComponent))
    .reduce((ret, pair) => ({...ret, [pair[0]]: pair[1] !== '' ? pair[1] : null}), {});
}

export const pageState = atom<PageState>({
  key: 'pageState',
  default: {location: 'unknown'},
  effects: [
    ({setSelf, getPromise}) => {
      (async () => {
        const init = await getPromise(initPageState);
        if (init.initialized) return;
        init.initialized = true;

        const query = getQuery();
        const token = getTokenByPath() || query['token'];
        const questionId = query['questionId'] != null ? parseInt(query['questionId']) : null;

        if (token != null && questionId != null && !Number.isNaN(questionId)) {
          setSelf({location: 'preview', token, questionId});
        } else if (token != null) {
          setSelf({location: 'main', token})
        } else {
          setSelf({location: 'unknown'});
        }
      })();
    }
  ]
});
